module.exports = __webpack_public_path__ + "static/media/2@2x.bee1db5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/2@2x.png
// module id = 1560
// module chunks = 0